module.exports = __webpack_public_path__ + "assets/2241949f9ccb6420821d1809bf1e6aee.png";